module.exports = __webpack_public_path__ + "img/quality.1fed71b.webp";